import { apiClient } from "@/shared/api/api-client";
import { endSession } from "@/shared/auth/oidc";

/** Quanto o "Sair" espera a API marcar a sessão como encerrada antes de
 *  seguir pro logout do Keycloak de qualquer jeito. */
export const REVOKE_TIMEOUT_MS = 2000;

/**
 * O "Sair" (2026-10-20): a API marca o `sid` desta aba como encerrado
 * (`POST /me/logout`), e só então a pessoa vai ao logout do Keycloak.
 *
 * O access token é auto-contido e valeria até expirar mesmo depois do
 * logout; com a marca, a API o recusa na hora — inclusive se o redirect
 * pro Keycloak não chegar ao fim. Falha ou demora da API não seguram a
 * saída: sair nunca pode depender dela.
 */
export async function revokeThenEndSession(accessToken: string | null, idToken: string | null): Promise<void> {
  if (accessToken) {
    await Promise.race([
      apiClient.logoutMySession(accessToken).catch(() => undefined),
      new Promise(resolve => window.setTimeout(resolve, REVOKE_TIMEOUT_MS))
    ]);
  }
  await endSession(idToken);
}
